import { Component,  OnInit, OnDestroy } from '@angular/core';


import { Router, NavigationEnd } from '@angular/router';
import { Subscription }   from 'rxjs';
import { filter } from 'rxjs/operators'

// imports for animations
import { trigger, transition, useAnimation } from '@angular/animations';
// ng-animate library
import { fadeInDown } from 'ng-animate';
// wow animation service  
import { NgwWowService } from 'ngx-wow';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown))]),
  ],
})


export class AppComponent implements OnInit, OnDestroy {

  title = 'qaysar-pizza';

  private wowSubscription: Subscription;
  private appTitle:string = environment.appTitle;  

  constructor(private router: Router, private wowService: NgwWowService,
    private _title:Title,
    public _TranslateService: TranslateService,
    ){
      if(localStorage.getItem('token')){
        localStorage.setItem('verification','true')
      }


      // this._TranslateService.use('en')
      
    // if (localStorage.getItem('lang')) {
    //   const lang = localStorage.getItem('lang');
    //   if (lang == 'en') {
    //   this._TranslateService.use('en');
    //   } else if (lang == 'ar') {
    //   this._TranslateService.use('ar');
    //   }
    //   } else {
    //   this._TranslateService.use('en');
    //   localStorage.setItem('lang', 'en');
    //   }

    // set page title
    this._title.setTitle(this.appTitle)
    
    this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(event => {
        // Reload WoW animations when done navigating to page,
        // but you are free to call it whenever/wherever you like
        this.wowService.init({
          mobile: false
        });
      });
  
  }



  ngOnInit() {
    // you can subscribe to WOW observable to react when an element is revealed
    this.wowSubscription = this.wowService.itemRevealed$.subscribe(
      (item:HTMLElement) => {
        // do whatever you want with revealed element
       
      });
  }

  
  ngOnDestroy() {
    // unsubscribe (if necessary) to WOW observable to prevent memory leaks
    this.wowSubscription.unsubscribe();
  }


}
